<template>
  <div>
    <loading-animation :active.sync="loading" :is-full-page="false" color="#5895FF" />

    <div id="boxPrint" class="row">
      <div class="col-md-12">
        <h4 class="text-center">Detalhes da Solicitação de Acolhimento</h4>

        <table class="table b-table table-bordered table-sm bg-white">
          <tbody>
            <!-- Protocolo e datas -->
            <tr>
              <td><b>Status:</b></td>
              <td>{{ statusTratado(item.status_solicitacao) || '-' }}</td>
              <td><b>Data da solicitação:</b></td>
              <td>{{ formatarData(item.data_solicitacao) }}</td>
            </tr>

            <!-- Técnico e Unidade -->
            <tr>
              <td colspan="2"><b>Responsável pela solicitação:</b> {{ item.resp_solicitacao }}</td>
              <td colspan="2"><b>Unidade Solicitante:</b> {{ unidadeSolicitanteDescricao }} </td>
            </tr>

            <!-- Público alvo -->
            <tr>
              <td colspan="2">
                <b>Público Alvo:</b> {{ getArrayValue('acolhimento_publico_alvo', item.publico_alvo_id) }}
                <span v-if="mostrarDescricaoPublico"> - {{ item.desc_publico_alvo }}</span>
              </td>
              <td colspan="2">
                <b>Origem da Solicitação:</b>
                {{ getArrayValue('acolhimento_origem_solicitacao', item.origem_solicitacao_id) }}
              </td>
            </tr>

            <!-- Serviço socioassistencial -->
            <tr>
              <td colspan="2"><b>Serviço Socioassistencial:</b> {{ servicoSelecionado?.value || '-' }}</td>
              <td colspan="2" v-if="mostrarDescricaoOutroServico">
                <b>Descrição do Serviço:</b> {{ item.desc_servico_socioassistencial }}
              </td>
            </tr>

            <!-- Dados do usuário -->
            <tr>
              <td colspan="2"><b>Nome do Usuário:</b> {{ item.nome_usuario }}</td>
              <td><b>Nome Social:</b> {{ item.nome_social }}</td>
              <td><b>CPF:</b> {{ item.cpf }}</td>
            </tr>
            <tr>
              <td><b>Nascimento:</b> {{ formatarData(item.nascimento) }}</td>
              <td><b>Gênero:</b> {{ getArrayValue('genero', item.genero_id) }}</td>
              <td><b>Deficiência:</b> {{ booleanText(item.deficiencia) }}</td>
            </tr>
            <tr v-if="mostrarDeficiencia">
              <td colspan="4"><b>Tipo de Deficiência:</b> {{ item.tipo_deficiencia }}</td>
            </tr>
            <tr>
              <td><b>Situação de Rua:</b> {{ booleanText(item.situacao_rua) }}</td>
              <td><b>Grupo de Irmãos:</b> {{ booleanText(item.grupo_irmaos) }}</td>
              <td colspan="2" v-if="mostrarNumeroIrmaos">
                <b>Número de Irmãos:</b> {{ item.numero_irmaos }}
              </td>
            </tr>
            <tr>
              <td colspan="2"><b>Termo de Acolhimento:</b> {{ item.termo_acolhimento }}</td>
              <td colspan="2">
                <b>Membros na Família:</b>
                <span v-if="Array.isArray(item.familia_membros)">
                  {{ item.familia_membros.map(id => getArrayValue('membros_na_familia', id)).join(', ') }}
                </span>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <b>Grau de Dependência:</b>
                {{ getArrayValue('acolhimento_grau_dependencia', item.grau_dependencia_id) }}
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <b>Motivo(s) do Acolhimento:</b>
                <span v-if="Array.isArray(item.motivo_acolhimento)">
                  {{ item.motivo_acolhimento.map(id => getArrayValue('motivos_acolhimento', id)).join(', ') }}
                </span>
              </td>
            </tr>
            <tr v-if="mostrarMotivoOutro">
              <td colspan="4">
                <b>Descrição do(s) Motivo(s):</b> {{ item.desc_motivo_acolhimento }}
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row pt-4 px-0 d-flex justify-content-end no-print">
          <div class="col-auto px-2 text-right">
            <router-link
              :to="{
                path: '/dashboard/acolhimento/gestao-vagas',
                query: $route.query
              }"
              class="btn btn-default"
            >
              <i class="mdi mdi-arrow-left" />
            </router-link>
            <a class="btn btn-sm py-1 btn-primary" @click="print">
              <i class="mdi mdi-printer mdi-18px" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      item: {},
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      servicos: this.$root.arrays.servicos || [],
      unidades: [],
      municipio: "",
    };
  },
  computed: {
    unidadeSolicitanteDescricao() {
      const lista = this.municipio === 'guarulhos'
        ? this.$root.arrays.unidade_solicitante_guarulhos || []
        : this.unidades || [];

      const unidade = lista.find(u => u.id == this.item.unidade_solicitante);
      return unidade ? unidade.value : this.item.unidade_solicitante || '-';
    },
    servicoSelecionado() {
      return this.servicos.find(s => s.id === this.item.servico_socioassistencial_id) || {};
    },
    mostrarDescricaoPublico() {
      return this.item.publico_alvo_id === 35;
    },
    mostrarDeficiencia() {
      return this.item.deficiencia == 1;
    },
    mostrarNumeroIrmaos() {
      return this.item.grupo_irmaos == 1;
    },
    mostrarMotivoOutro() {
      return this.item.motivo_acolhimento?.some(id => id === 19);
    },
    mostrarDescricaoOutroServico() {
      const s = this.servicoSelecionado;
      return s?.value?.toUpperCase() === 'OUTROS';
    }
  },
  async mounted() {
    await this.buscarMunicipio();
    await this.getUnidades();
    this.getItem();
  },
  methods: {
    async buscarMunicipio() {
      this.municipio = this.$store.state.municipio.toLowerCase();

    },
    async getUnidades() {  
      this.load = true;
      const response = await axios.get("api/dashboard/unidades");
      this.unidades = response.data.data.map((item) => ({
        id: String(item.id),
        value: item.nome
      }));
    },
    getItem() {
      axios.get(`/api/dashboard/acolhimento/solicitacao/${this.$route.params.id}`)
          .then(res => {
              this.item = res.data.data;
              this.loading = false;
          });
    },
    formatarData(dataStr) {
      if (!dataStr) return '-';
      const data = new Date(dataStr);
      return data.toLocaleDateString('pt-BR');
    },
    statusTratado(status) {
        if (!status) return '-';

        const statusUpper = status.toString().toUpperCase();

        if (statusUpper === 'PENDENTE' || statusUpper === 'AGUARDANDO_VAGA') {
        return 'Aguardando vaga';
        }

        // Adicione outras regras, se quiser:
        if (statusUpper === 'APROVADO') {
        return 'Aprovado';
        }

        if (statusUpper === 'REJEITADO') {
        return 'Rejeitado';
        }

        return status; // Retorna o original caso não se enquadre em nenhuma regra
    },
    getArrayValue(arrayKey, id) {
      const lista = this.$root.arrays[arrayKey] || [];
      const item = lista.find(el => el.id == id);
      return item ? item.value : '-';
    },
    booleanText(val) {
      return val == 1 ? 'Sim' : 'Não';
    },
    print() {
      const modal = document.getElementById("boxPrint");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    }
  }
};
</script>

<style scoped>
@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
  }
  #print {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
